import React from 'react';
import SalesDocumentList from '@/pages/SalesDocuments/SalesDocumentList';
import { QUOTATION } from '@/pages/SalesDocuments/documentTypes';

export default function QuotationsPage() {
  return <SalesDocumentList docType={QUOTATION} />;
}
